// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CalculationType } from '../app/models/calculation-type';
import { AngleNumbers } from '../app/services/angle-numbers';

export const environment = {
  production: false,
  // apiAddress: 'http://localhost:8080',
  apiAddress: 'https://app.performai.tech',
  // apiAddress: 'https://testapp.performai.tech',
  backgroundRemover: 'https://app.performai.tech',
  enableAsync2D: true,
  enableAsync3D: true,
  smallDeviceWidth: 480,
  chatEnabled: false,
  aiAnalysisEnabled: true,
  activationZoneFootballPlayer: 'Lionel Messi',
  activationZonePadelPlayer: 'FERNANDO BELASTEGUÍN',
  showDetailedData: {
    science: false,
    fun: true,
    test: true,
    messi: true,
    maradona: true,
    maradona2: true,
    golf: true,
    brad: true,
    ben: true,
    benScience: false,
    benScienceCopy: false,
    dartScience: false,
    jump: false,
    judo: true,
    paddle: true,
  },
  showIntros: {
    science: false,
    fun: true,
    test: true,
    messi: true,
    maradona: true,
    maradona2: true,
    golf: true,
    brad: true,
    ben: true,
    benScience: false,
    benScienceCopy: false,
    dartScience: false,
    jump: false,
    judo: true,
    paddle: true,
  },
  hideCompareVideos: {
    science: false,
    fun: false,
    test: false,
    messi: false,
    maradona: false,
    maradona2: false,
    golf: false,
    brad: false,
    ben: false,
    benScience: false,
    benScienceCopy: false,
    dartScience: false,
    jump: true,
    judo: false,
    paddle: false,
  },
  manualPlays: {
    science: false,
    fun: false,
    test: false,
    messi: false,
    maradona: false,
    maradona2: false,
    golf: false,
    brad: false,
    ben: false,
    benScience: true,
    benScienceCopy: true,
    dartScience: true,
    jump: true,
    judo: false,
    paddle: false,
  },
  playerNames: {
    science: 'Lionel Messi',
    fun: 'Lionel Messi',
    test: 'Lionel Messi',
    messi: 'Lionel Messi',
    maradona: 'Diego Armando Maradona',
    maradona2: 'Diego Armando Maradona',
    golf: 'Tiger Woods',
    brad: 'Brad Stephenson',
    ben: 'Acceleration-Deceleration AZ Player',
    benScience: 'Acceleration-Deceleration AZ Player',
    benScienceCopy: 'Acceleration-Deceleration AZ Player',
    dartScience: 'Acceleration-Deceleration AZ Player',
    jump: 'Jump AZ Player',
    judo: 'Judo pro player Iran',
    paddle: 'Padel Backhand',
  },
  actions: {
    science: 'Lionel Messi Penalty Kick (Be careful)',
    fun: 'Lionel Messi Penalty Kick (Be careful)',
    test: 'Lionel Messi Penalty Kick (Be careful)',
    messi: 'Messi Argentina Penalty',
    maradona: 'Maradona Penalty Kick - Italy v Argentina (1990)',
    maradona2: 'Maradona Penalty Kick - Italy v Argentina (1990)',
    golf: 'Golf new',
    brad: 'Final Golf Simulator Brad',
    ben: 'Acceleration-deceleration ability',
    benScience: 'Acceleration-deceleration ability',
    benScienceCopy: 'Acceleration-deceleration ability',
    dartScience: 'Acceleration-deceleration ability',
    jump: 'Activation Zone Jump Video (Do not delete)',
    judo: 'Oseto Gari PerformAI Ref (Iran)',
    paddle: 'Alejandro Galan Backhand - AZ',
  },
  standTitles: {
    science: 'Score Like Messi',
    fun: 'Score Like Messi',
    test: 'Score Like Messi',
    messi: 'Score Like Messi',
    maradona: 'Kick with Maradona ;)',
    maradona2: 'Kick with Maradona ;)',
    golf: 'Try Golf',
    brad: 'Try Golf',
    ben: 'Acceleration-Deceleration Ability',
    benScience: 'Acceleration-Deceleration Ability',
    benScienceCopy: 'Acceleration-Deceleration Ability',
    dartScience: 'AI Dart Performance Analysis',
    jump: 'Be ready to jump',
    judo: 'Try Judo Osoto Gari Technique',
    paddle: 'Try AI Powered Padel Forehand :)',
  },
  standImages: {
    science: 'activation-zone/stands/Messi with stroke.png',
    fun: 'activation-zone/stands/Messi with stroke.png',
    test: 'activation-zone/stands/Messi with stroke.png',
    messi: 'activation-zone/stands/messi_stand_1.png',
    maradona: 'activation-zone/stands/maradona_stand_2.png',
    maradona2: 'activation-zone/stands/maradona_stand_2.png',
    golf: 'activation-zone/stands/golf_stand.png',
    brad: 'activation-zone/stands/brad_stand.png',
    ben: 'activation-zone/stands/ben_stand.png',
    benScience: 'activation-zone/stands/ben_stand.png',
    benScienceCopy: 'activation-zone/stands/ben_stand.png',
    dartScience: 'activation-zone/stands/ben_stand.png',
    jump: 'activation-zone/stands/jump_ai.png',
    judo: 'activation-zone/judo_stand.png',
    paddle: 'activation-zone/stands/padel_stand.png',
  },
  dialogTitles: {
    padel: 'Can you do hit like me?',
    science: 'Can you do kick like me?',
    fun: 'Can you do kick like me?',
    test: 'Can you do kick like me?',
    messi: 'Can you do a penalty kick like me?',
    maradona: 'Can you do a penalty kick like me?',
    maradona2: 'Can you do a penalty kick like me?',
    golf: 'Can you play Golf like I Do?',
    brad: 'Can you play Golf like I Do?',
    ben: 'Can you do acceleration and deceleration backward test ?',
    benScience: 'Can you do acceleration and deceleration backward test ?',
    benScienceCopy: 'Can you do acceleration and deceleration backward test ?',
    dartScience: 'Can you do acceleration and deceleration backward test ?',
    jump: 'Ready for AI Titan Games 2025 in jumping?',
    judo: 'Let’s go for warm up. Are you ready?',
    paddle: 'Try AI Powered Padel Forehand :)',
  },
  dialogMedia: {
    padel: 'activation-zone/dialog_media/FERNANDO BELASTEGUIN pael-0-Enhanced-Animated.mp4',
    science: 'activation-zone/dialog_media/lionelmessi.mp4',
    fun: 'activation-zone/dialog_media/lionelmessi.mp4',
    test: 'activation-zone/dialog_media/lionelmessi.mp4',
    messi: 'activation-zone/dialog_media/messi_dialog_img2.jpg',
    maradona: 'activation-zone/dialog_media/maradona_dialog_img.jpg',
    maradona2: 'activation-zone/dialog_media/maradona_dialog_img.jpg',
    golf: 'activation-zone/dialog_media/Tiger Woods.mp4',
    brad: 'activation-zone/dialog_media/brad_stephenson.jpg',
    ben: 'activation-zone/dialog_media/acc_dec_ben.png',
    benScience: 'activation-zone/dialog_media/acc_dec_ben.png',
    benScienceCopy: 'activation-zone/dialog_media/acc_dec_ben.png',
    dartScience: 'activation-zone/dialog_media/acc_dec_ben.png',
    jump: 'activation-zone/dialog_media/jump.png',
    judo: 'activation-zone/dialog_media/judo_dialog.png',
    paddle: 'activation-zone/dialog_media/paddle.jpg',
  },
  compareImage: {
    science: 'activation-zone/compare_images/lionel-messi-276.png',
    fun: 'activation-zone/compare_images/lionel-messi-276.png',
    test: 'activation-zone/compare_images/lionel-messi-276.png',
    messi: 'activation-zone/compare_images/messi_argentina.png',
    maradona: 'activation-zone/compare_images/maradona_2.png',
    maradona2: 'activation-zone/compare_images/maradona_2.png',
    golf: 'activation-zone/compare_images/Gold-New.png',
    brad: 'activation-zone/compare_images/Golf-Brad.png',
    ben: 'activation-zone/compare_images/ben_compare.png',
    benScience: 'activation-zone/compare_images/science_ben_compare_black.png',
    benScienceCopy: 'activation-zone/compare_images/science_ben_compare_black.png',
    dartScience: 'activation-zone/compare_images/science_ben_compare_black.png',
    jump: 'activation-zone/compare_images/jump_compare.png',
    judo: 'activation-zone/compare_images/judo_player.png',
    paddle: 'activation-zone/compare_images/paddle_compare.png',
  },
  afterPlayVideos: {
    science: 'activation-zone/after_play/5 new.mp4',
    fun: 'activation-zone/after_play/5 new.mp4',
    test: 'activation-zone/after_play/5 new.mp4',
    messi: 'activation-zone/after_play/messi_argentina.mp4',
    maradona: 'activation-zone/after_play/maradona.mp4',
    maradona2: 'activation-zone/after_play/maradona.mp4',
    golf: 'activation-zone/after_play/5 new.mp4',
    brad: 'activation-zone/after_play/brad_after_play.mp4',
    ben: 'activation-zone/after_play/5 new.mp4',
    benScience: 'activation-zone/after_play/5 new.mp4',
    benScienceCopy: 'activation-zone/after_play/5 new.mp4',
    dartScience: 'activation-zone/after_play/5 new.mp4',
    jump: 'activation-zone/after_play/5 new.mp4',
    judo: 'activation-zone/after_play/5 new.mp4',
    paddle: 'activation-zone/after_play/5 new.mp4',
  },
  allRecordingKeyPercents: {
    science: [0, 0.81, 0.95, 1],
    fun: [0, 0.81, 0.95, 1],
    test: [0, 0.81, 0.95, 1],
    messi: [0, 0.22, 0.43, 1],
    maradona: [0, 0.63, 0.95, 1],
    maradona2: [0, 0.63, 0.95, 1],
    golf: [0, 0.293, 0.62, 1],
    brad: [0.535, 0.79, 0.94, 1],
    ben: [0, 0.293, 0.62, 1],
    benScience: [0, 0.293, 0.62, 1],
    benScienceCopy: [0, 0.293, 0.62, 1],
    dartScience: [0, 0.293, 0.62, 1],
    jump: [0, 0.293, 0.62, 1],
    judo: [0, 0.22, 0.43, 1],
    paddle: [0, 0.42, 0.83, 1],
  },
  serverSideActivationZoneCalculations: {
    science: false,
    fun: false,
    test: false,
    messi: false,
    maradona: false,
    maradona2: false,
    golf: false,
    brad: false,
    ben: false,
    benScience: true,
    benScienceCopy: true,
    dartScience: true,
    jump: true,
    judo: false,
    paddle: false,
  },
  allScienceParameters: {
    brad: {
      scoring: [
        {
          type: CalculationType.angle,
          indexes: [AngleNumbers.shoulderLeft, AngleNumbers.shoulderRight],
          ranges: [
            { min: 60, max: 75, score: 0.25 },
            { min: 75, max: 80, score: 0.5 },
            { min: 80, max: 90, score: 1 },
            { min: 90, max: 95, score: 0.5 },
          ]
        },
        {
          type: CalculationType.angle,
          indexes: [AngleNumbers.hipLeft, AngleNumbers.hipRight],
          ranges: [
            { min: 140, max: 155, score: 0.25 },
            { min: 155, max: 160, score: 0.5 },
            { min: 160, max: 180, score: 1 },
            { min: 180, max: 185, score: 0.5 },
          ]
        },
        {
          type: CalculationType.angle,
          indexes: [AngleNumbers.ankleLeft, AngleNumbers.ankleRight],
          ranges: [
            { min: 135, max: 145, score: 0.25 },
            { min: 145, max: 155, score: 0.5 },
            { min: 155, max: 170, score: 1 },
            { min: 170, max: 175, score: 0.5 },
          ]
        },
        {
          type: CalculationType.angle,
          indexes: [AngleNumbers.wristLeft, AngleNumbers.wristRight],
          ranges: [
            { min: 135, max: 145, score: 0.25 },
            { min: 145, max: 150, score: 0.5 },
            { min: 150, max: 160, score: 1 },
            { min: 160, max: 165, score: 0.5 },
          ]
        },
      ]
    },
    benScience: {
      customMethod: 'accDec',
    },
    benScienceCopy: {
      customMethod: 'accDec',
    },
    dartScience: {
      customMethod: 'dart',
    },
    jump: {
      customMethod: 'jump',
    }
  },
  showCard: ['maradona', 'golf', 'brad', 'jump', 'paddle'],
  cardThemes: {
    maradona: 'give-and-get',
    golf: 'commercial-bank',
    jump: 'jump',
    paddle: 'oasis'
  },
  priceUnit: {
    'give-and-get': '$',
    'commercial-bank': 'QAR',
    'commercial-bank-brad': 'QAR',
    jump: ' QAR',
    oasis: ' QAR',
  },
  cardUrls: {
    'give-and-get': 'https://secure.giveandget.io/register',
    'commercial-bank': 'https://www.cbq.qa/EN/Expat/pages/apply-qatari-bank-account.aspx',
    'commercial-bank-brad': 'https://www.cbq.qa/EN/Expat/pages/apply-qatari-bank-account.aspx',
    jump: 'https://onelink.to/dadqxn',
    oasis: 'https://public.dohaoasis.com/survey/padel'
  },
  cardThresholds: {
    'give-and-get': [35, 45, 55, 65, 75],
    'commercial-bank': [0, 45, 55, 65, 75],
    'commercial-bank-brad': [0, 45, 55, 65, 75],
    jump: [0, 30, 35, 40, 45],
    oasis: [0, 30, 35, 40, 45],
  },
  cardValues: {
    'give-and-get': [50, 100, 250, 500, 1000],
    'commercial-bank': [1000, 500, 1000, 500, 1000],
    'commercial-bank-brad': [100, 50, 100, 50, 100],
    jump: [50, 100, 200, 300, 400],
    oasis: [50, 100, 200, 300, 400],
  }
};
